import React, { useState, useRef, useEffect } from "react";

const TapDetector = ({
  tapThreshold = 10,
  tapWindow = 300,
  onThresholdReached,
  children,
}) => {
  const [tapCount, setTapCount] = useState(0);
  const tapTimerRef = useRef(null);
  const tapCountRef = useRef(0);

  useEffect(() => {
    const handleTap = () => {
      tapCountRef.current += 1;
      const newCount = tapCountRef.current;

      if (tapTimerRef.current) {
        clearTimeout(tapTimerRef.current);
      }

      tapTimerRef.current = setTimeout(() => {
        tapCountRef.current = 0;
      }, tapWindow);

      if (newCount >= tapThreshold) {
        tapCountRef.current = 0;
        if (tapTimerRef.current) {
          clearTimeout(tapTimerRef.current);
        }
        if (onThresholdReached) {
          setTimeout(() => onThresholdReached(), 0);
        }
      }
    };

    document.addEventListener('click', handleTap);
    return () => {
      document.removeEventListener('click', handleTap);
      if (tapTimerRef.current) {
        clearTimeout(tapTimerRef.current);
      }
    };
  }, [tapThreshold, tapWindow, onThresholdReached]);

  return <>{children}</>;
};

export default TapDetector;
